/**
 * Anzeige-Reihenfolge der Dienstleistungen (Fallback im Frontend).
 * Niedriger = weiter oben.
 * Gruppen: Garage → Carrosserie → Pannen → Reinigung
 */
export const SERVICE_SORT_ORDER = {
  'Fahrzeugreparatur': 10,
  'Fahrzeugdiagnostik': 20,
  'Diagnose': 25,
  'Service & Wartung': 30,
  'Service und Unterhalt': 35,
  'Service': 36,
  'Inspektion': 38,
  'MFK-Vorbereitung': 40,
  'Bremsen': 42,
  'Klimaanlage': 44,
  'Räder und Reifen': 46,
  'Carrosserie': 50,
  'Lackiererei': 55,
  'Verglasung': 60,
  'Schadenabwicklung': 65,
  'Pannendienst': 70,
  'Mobilitätsgarantie stop+go': 75,
  'Unfallbergung': 80,
  'Autovermietung': 85,
  'Ölspurreinigung': 90,
  'Schächte absaugen': 95,
  'Belagsreinigung': 100,
};

export function sortServices(services) {
  if (!Array.isArray(services)) return [];
  return [...services].sort((a, b) => {
    const ao = SERVICE_SORT_ORDER[a.title] ?? (a.sort_order ?? 500);
    const bo = SERVICE_SORT_ORDER[b.title] ?? (b.sort_order ?? 500);
    if (ao !== bo) return ao - bo;
    return String(a.title || '').localeCompare(String(b.title || ''), 'de');
  });
}

export const SERVICES_PAGE_INTRO = {
  title: 'Leistungen in Davos',
  lead:
    'Von stop+go Service und Diagnose über Pannendienst und Mobilitätsgarantie bis zu Carrosserie, Lack, Verglasung und Schadenabwicklung – die Sportplatzgarage Gutknecht ist Ihr Ansprechpartner an der Mattastrasse 46.',
};
